import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 'auto',
    width: '70%',
    maxWidth: 1700,
    padding: 24,
    marginTop: '5vh',
    marginBottom: '5vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 12,
    backgroundColor: theme.palette.background.default,
    height: 'fill-available',
    overflowY: 'scroll',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  },
  circularProgressContianer: {
    marginTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }
}))
export default useStyles
